var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyInfoSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 32.7 32.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.my-info-cls-1{fill:#fff;}.my-info-cls-2{fill:#fcbc00;}\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tMyInfo_Selected\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "my-info-cls-1",
    d: "M16.35,0A16.35,16.35,0,1,0,32.7,16.35,16.4,16.4,0,0,0,16.35,0Zm0,29.63A13.28,13.28,0,1,1,29.63,16.35,13.25,13.25,0,0,1,16.35,29.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "my-info-cls-2",
    cx: 16.35,
    cy: 10.22,
    r: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "my-info-cls-2",
    d: "M16.35,14.3a2.05,2.05,0,0,0-2.05,2.05v6.13a2,2,0,0,0,4.09,0V16.35A2.05,2.05,0,0,0,16.35,14.3Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyInfoSelected);
export default __webpack_public_path__ + "static/media/my-info-selected.b3f9a30c028163d5c95cda0b62ded511.svg";
export { ForwardRef as ReactComponent };